import { ChangeEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const useBulkTmsModalUpload = () => {
  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    console.log({ file });
  }, [file]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const splittedFileNameAndExtension = e.target.files[0].name.split('.');
      console.log(splittedFileNameAndExtension[splittedFileNameAndExtension.length - 1]);

      if (
        ['xlsx', 'csv'].indexOf(
          splittedFileNameAndExtension[splittedFileNameAndExtension.length - 1]
        ) === -1
      ) {
        toast.error('Invalid file type selected, Please select .xlsx or .csv file');
      } else {
        setFile(e.target.files[0]);
      }
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
  };

  return {
    file,
    handleFileChange,
    handleRemoveFile,
  };
};

export default useBulkTmsModalUpload;
